export default __webpack_public_path__ + "static/media/FoodChainOcean_02.93af38d5.png";